module.exports = __webpack_public_path__ + "img/clock-seven-thirty.ed06a247.svg";